export default __webpack_public_path__ + "static/media/logofooter.d392f1f8.svg";